import * as React from "react";
import { Archive, Trash2, FolderInput, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Card } from "@/components/ui/card";

type BulkActionsToolbarProps = {
  selectedCount: number;
  onArchive: () => void;
  onDelete: () => void;
  onChangeStatus: (status: "draft" | "published" | "archived") => void;
  onMoveToFolder: () => void;
  onDeselectAll: () => void;
};

export function BulkActionsToolbar({
  selectedCount,
  onArchive,
  onDelete,
  onChangeStatus,
  onMoveToFolder,
  onDeselectAll,
}: BulkActionsToolbarProps) {
  if (selectedCount === 0) return null;

  return (
    <Card className="fixed bottom-6 left-1/2 z-50 -translate-x-1/2 border-primary shadow-lg">
      <div className="flex items-center gap-4 px-4 py-3">
        <div className="flex items-center gap-2">
          <span className="text-sm font-medium">
            {selectedCount} {selectedCount === 1 ? "document" : "documents"} selected
          </span>
          <Button variant="ghost" size="sm" onClick={onDeselectAll}>
            <X className="size-4" />
          </Button>
        </div>

        <div className="h-6 w-px bg-border" />

        <div className="flex items-center gap-2">
          <Button variant="outline" size="sm" onClick={onArchive}>
            <Archive className="mr-2 size-4" />
            Archive
          </Button>

          <Button variant="outline" size="sm" onClick={onDelete}>
            <Trash2 className="mr-2 size-4" />
            Delete
          </Button>

          <Select onValueChange={(value) => onChangeStatus(value as any)}>
            <SelectTrigger className="h-9 w-[140px]">
              <SelectValue placeholder="Change status" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="draft">Draft</SelectItem>
              <SelectItem value="published">Published</SelectItem>
              <SelectItem value="archived">Archived</SelectItem>
            </SelectContent>
          </Select>

          <Button variant="outline" size="sm" onClick={onMoveToFolder}>
            <FolderInput className="mr-2 size-4" />
            Move to folder
          </Button>
        </div>
      </div>
    </Card>
  );
}
